import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css';

import AppHeader from './components/AppHeader'
import Footer from './components/Footer';
import Home from './pages/Home'
import Tools from './pages/Tools'
import About from './pages/About'
import ImageReducer from './pages/tools/ImageReducer'
import ResumeTemplates from './pages/tools/ResumeTemplates'
import ResumeBuilder from './pages/tools/ResumeBuilder'
import ResumeAnalyzer from './pages/tools/ResumeAnalyzer'
import ApplicationForms from './pages/tools/ApplicationForms'
import FypIdeas from './pages/tools/FypIdeas'
import OldFypProjects from './pages/tools/OldFypProjects'
import PDFMerger from './pages/tools/PDFMerger';
import VideoConverter from './pages/tools/VideoConverter';

function App() {
  return (
    <Router>
      <AppHeader />
      <div className="app-container">
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/about" element={<About />} />
          <Route path="/tools/image-reducer" element={<ImageReducer />} />
          <Route path="/tools/resume-templates" element={<ResumeTemplates />} />
          <Route path="/tools/resume-builder" element={<ResumeBuilder />} />
          <Route path="/tools/resume-analyzer" element={<ResumeAnalyzer />} />
          <Route path="/tools/application-forms" element={<ApplicationForms />} />
          <Route path="/tools/fyp-ideas" element={<FypIdeas />} />
          <Route path="/tools/old-fyp-projects" element={<OldFypProjects />} />
          <Route path="/tools/pdf-merger" element={<PDFMerger />} />
          <Route path="/tools/video-converter" element={<VideoConverter />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  )
}

export default App;
